window.addEventListener("resize", () => {
  if (window.innerWidth > 750) {
    let slideshow__media = document.querySelectorAll(
      ".slideshow__media img"
    )[0];
    const sliderBanner = document.querySelectorAll(".slideshow.banner")[0] || {
      style: { height: "" },
    };

    if (slideshow__media && sliderBanner?.style) {
      sliderBanner.style.height = slideshow__media.clientHeight + "px";
    }
  }
});
